import { connect } from "react-redux";
import MaterialRequisition from "./materialRequisition";
import { bindActionCreators } from "redux";
import {
  getMrfDetails,
  postReportDetails,
  postApproval,
  postSendProcurement,
} from "services/redux/installation/materialRequisition/action";

import {
  getSiteInspect
} from "services/redux/installation/siteInspection/action";

const mapStateToProps = (state) => ({
  mrfDetails: state.mrfDetailsReducer.mrfDetails,
  siteData: state.siteInspectionReducer.siteData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMrfDetails,
      postReportDetails,
      postApproval,
      postSendProcurement,
      getSiteInspect
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaterialRequisition);
